module.exports = __webpack_public_path__ + "img/sku1.700eb441.png";